import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { MB_JOB_TITLE_NORMALIZER, MbJobTitlesAdapter } from '../connectors'
import { pluck } from 'rxjs/operators'

@Injectable({
  providedIn: 'root',
})
export class MbOccJobTitlesAdapter implements MbJobTitlesAdapter {

  constructor (protected http: HttpClient,
              protected occEndpoints: OccEndpointsService,
              protected converter: ConverterService) {
  }

  load () {
    return this.http.get(this.getEndpoint()).pipe(
      pluck('jobTitles'),
      this.converter.pipeable(MB_JOB_TITLE_NORMALIZER)
    )
  }

  protected getEndpoint () {
    return this.occEndpoints.buildUrl('jobTitles')
  }
}
